/* unplugin-vue-components disabled */import { render } from "./add-modal.vue?vue&type=template&id=7dc139a2&scoped=true"
import script from "./add-modal.vue?vue&type=script&lang=js"
export * from "./add-modal.vue?vue&type=script&lang=js"

import "./add-modal.vue?vue&type=style&index=0&id=7dc139a2&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc139a2"],['__file',"src/pages/tenants/user/contacts/add-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7dc139a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7dc139a2', __exports__)) {
    api.reload('7dc139a2', __exports__)
  }
  
  module.hot.accept("./add-modal.vue?vue&type=template&id=7dc139a2&scoped=true", () => {
    api.rerender('7dc139a2', render)
  })

}


export default __exports__